export default __webpack_public_path__ + "static/media/fixture1_filter_win.d9c933b6.png";